import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useRef, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Popover } from "@reach/popover";
import { MultiSliderHandleImpl, MultiSliderValueDisplay, MultiSliderHandleValueLabel } from "./multi-slider-handle.styles.es.js";
import { positionTopCenter } from "../../utils/popover-position.es.js";
const propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  enableTooltip: PropTypes.bool,
  max: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  onMouseDown: PropTypes.func,
  onSelect: PropTypes.func,
  percent: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  valueLabel: PropTypes.string
};
const defaultProps = {
  active: false,
  disabled: false,
  enableTooltip: false,
  onMouseDown: () => {
  },
  onSelect: () => {
  },
  valueLabel: void 0
};
const MultiSliderHandle = ({
  active,
  disabled,
  enableTooltip,
  max,
  min,
  onMouseDown,
  onSelect,
  percent,
  value,
  valueLabel,
  ...restProps
}) => {
  const ref = useRef();
  const [hasHover, setHover] = useState(false);
  const handleMouseEnter = useCallback(() => {
    setHover(true);
  }, []);
  const handleMouseLeave = useCallback(() => {
    setHover(false);
  }, []);
  const handleMouseDown = useCallback(
    (e) => {
      onMouseDown(e);
      onSelect([value]);
    },
    [onMouseDown, onSelect, value]
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      MultiSliderHandleImpl,
      {
        ref,
        role: "slider",
        "aria-disabled": disabled || void 0,
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value,
        disabled,
        left: `${percent}%`,
        onMouseDown: handleMouseDown,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        tabIndex: "0",
        ...restProps
      }
    ),
    enableTooltip && (active || hasHover) && /* @__PURE__ */ jsx(Popover, { position: positionTopCenter, targetRef: ref, children: /* @__PURE__ */ jsxs(MultiSliderValueDisplay, { children: [
      value,
      valueLabel && /* @__PURE__ */ jsx(MultiSliderHandleValueLabel, { children: valueLabel })
    ] }) })
  ] });
};
MultiSliderHandle.propTypes = propTypes;
MultiSliderHandle.defaultProps = defaultProps;
export {
  MultiSliderHandle
};
